// // src/pages/treatments/KidneyTransplantPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const KIDNEY_TRANSPLANT_TREATMENT = {
//   slug: "kidney-transplant",
//   name: "Kidney Transplant",
//   shortName: "Kidney Transplant",
//   tagline: "Freedom from Dialysis. A New Kidney. A New Life.",
//   heroSubtag:
//     "World-class kidney transplant surgery at a fraction of Western costs. India's top transplant nephrologists and urologists. Life-changing outcomes.",
//   description:
//     "Comprehensive kidney transplant care covering living donor, deceased donor and pre-emptive transplants — supported by advanced nephrology, dedicated transplant ICUs, immunosuppression management and lifelong post-transplant follow-up. Our multidisciplinary transplant boards review every international case within 48 hours to deliver globally benchmarked, personalised treatment plans with outstanding graft survival rates.",
//   heroImage: "/KidneyTransplant.jpeg",
//   category: "Organ Transplant",
//   badge: "Life-Saving Surgery",
//   accentColor: "blue", 
//   costCard: {
//     label: "Kidney transplant packages",
//     value: "₹8L–₹12L",
//     compare: "vs. $150,000–$300,000 in the USA",
//     stay: "Typically 3–4 weeks in India post-surgery",
//     stayCompare: "vs. £80,000–£150,000 in the UK",
//   },
//   stats: [
//     { label: "1-Year Graft Survival", value: "95%+", icon: Award },
//     { label: "Transplants Performed", value: "8,000+", icon: Users },
//     { label: "Years Experience", value: "30+", icon: Shield },
//     { label: "Avg. Hospital Stay", value: "10–14 Days", icon: Clock },
//   ],
//   benefits: [
//     "Living donor and deceased donor kidney transplant programmes",
//     "Pre-emptive transplant — surgery before dialysis is required",
//     "ABO-incompatible kidney transplant with desensitisation protocol",
//     "Laparoscopic donor nephrectomy — minimal scarring, faster donor recovery",
//     "Advanced HLA tissue typing and cross-matching laboratory on site",
//     "Dedicated transplant nephrology team for lifelong immunosuppression management",
//     "Comprehensive donor workup — medical, surgical, psychological and ethical evaluation",
//     "Paediatric kidney transplant programme from infancy onwards",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Evaluation & Recipient Work-Up",
//       desc: "Complete nephrology assessment — GFR measurement, cardiac clearance, vascular imaging, HLA typing, donor compatibility testing and transplant committee approval.",
//       duration: "5–7 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Living Donor Assessment",
//       desc: "Independent full medical, surgical, psychological and ethical evaluation of the donor including renal function tests, CT angiography and 24-hour urine protein.",
//       duration: "5–7 Days",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Transplant Surgery",
//       desc: "Simultaneous laparoscopic donor nephrectomy and recipient kidney transplant by senior transplant urologist under general anaesthesia.",
//       duration: "3–5 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Recovery & Long-Term Follow-Up",
//       desc: "Transplant ICU monitoring, immunosuppression initiation, daily creatinine tracking and discharge with lifelong outpatient nephrology follow-up protocol.",
//       duration: "10–14 Days",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "Who needs a kidney transplant?",
//       a: "Kidney transplant is the gold-standard treatment for end-stage renal disease (ESRD) — when kidney function falls below 15% (GFR < 15 ml/min). Common causes include diabetic nephropathy, hypertensive nephropathy, glomerulonephritis, polycystic kidney disease and chronic pyelonephritis. A transplant offers a longer, better-quality life compared to dialysis.",
//     },
//     {
//       q: "What is a living donor kidney transplant?",
//       a: "A healthy family member or spouse (typically aged 18–60, blood group compatible) donates one of their two kidneys. People live full, healthy lives with one kidney. The donor undergoes laparoscopic (keyhole) nephrectomy and is typically discharged within 3–4 days. Living donor transplants have better long-term outcomes than deceased donor transplants.",
//     },
//     {
//       q: "What is ABO-incompatible kidney transplant?",
//       a: "Normally, donor and recipient must have compatible blood groups. ABO-incompatible transplant uses a desensitisation protocol — plasmapheresis and rituximab — to remove blood group antibodies before surgery, allowing transplantation across blood groups. India's top centres perform this routinely with excellent outcomes, opening options for patients whose only available donor has an incompatible blood group.",
//     },
//     {
//       q: "What is the graft survival rate for kidney transplant in India?",
//       a: "Leading Indian transplant centres report 1-year graft survival rates of 94–97% and 5-year graft survival rates of 85–90% — comparable to the best transplant centres in the USA and Europe. Living donor transplants consistently outperform deceased donor transplants in long-term graft function.",
//     },
//     {
//       q: "How long will I need to stay in India after kidney transplant?",
//       a: "Recipients typically stay 3–4 weeks post-surgery — approximately 10–14 days in hospital followed by 7–10 days of close outpatient monitoring before being cleared to fly. The living donor is usually discharged within 3–4 days. PaxGrow arranges serviced accommodation near the hospital for accompanying family throughout the recovery period.",
//     },
//     {
//       q: "Can I bring my own living donor from my home country?",
//       a: "Yes. Many international patients travel with a family member as the living donor. PaxGrow arranges medical visas for both recipient and donor simultaneously. The donor undergoes full independent evaluation at the Indian hospital before surgery is confirmed. Blood group compatibility and proof of relationship (or affidavit for emotionally related donors) are required.",
//     },
//     {
//       q: "What immunosuppression will I need after kidney transplant?",
//       a: "All kidney transplant recipients require lifelong immunosuppression. The standard triple therapy includes tacrolimus, mycophenolate mofetil and prednisolone. Your Indian transplant team provides a detailed protocol and coordinates with your home nephrologist for ongoing prescriptions. Monthly blood monitoring of creatinine, tacrolimus levels and full blood count is required for life.",
//     },
//     {
//       q: "How much does kidney transplant cost in India vs. the UK or USA?",
//       a: "A complete kidney transplant package in India (including donor evaluation, surgery, hospital stay, immunosuppression initiation and 30-day follow-up) typically costs ₹8L–₹12L ($10,000–$15,000), compared to £80,000–£150,000 in the UK and $150,000–$300,000 in the USA — with equivalent or superior graft survival outcomes at top Indian centres.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Sandeep Guleria",
//       specialty: "Kidney Transplant & Urology",
//       experience: "28 Years",
//       rating: 4.9,
//       reviews: 3400,
//       image: "https://randomuser.me/api/portraits/men/52.jpg",
//       qualifications: "MBBS, MS, MCh (Urology), FRCS",
//       hospital: "Indraprastha Apollo Hospital, New Delhi",
//     },
//     {
//       name: "Dr. Georgi Abraham",
//       specialty: "Transplant Nephrology",
//       experience: "32 Years",
//       rating: 4.9,
//       reviews: 2900,
//       image: "https://randomuser.me/api/portraits/men/63.jpg",
//       qualifications: "MBBS, MD (Medicine), DM (Nephrology), FRCP",
//       hospital: "Madras Medical Mission, Chennai",
//     },
//     {
//       name: "Dr. Sunil Shroff",
//       specialty: "Renal Transplant Surgery",
//       experience: "30 Years",
//       rating: 4.9,
//       reviews: 3100,
//       image: "https://randomuser.me/api/portraits/men/71.jpg",
//       qualifications: "MBBS, MS, MCh (Urology), FRCS (Edinburgh)",
//       hospital: "MIOT International, Chennai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "John Odhiambo",
//       age: 44,
//       location: "Nairobi, Kenya",
//       text: "I had been on haemodialysis three times a week for two years. It was destroying my quality of life. My brother donated one of his kidneys in Delhi. Ten days after surgery my creatinine was 1.1 — completely normal. I flew home after three weeks and have not been on dialysis since. PaxGrow handled every single detail from visa to airport pickup to accommodation. I owe my life to this team.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/44.jpg",
//       treatment: "Living Donor Kidney Transplant — Diabetic Nephropathy",
//       date: "September 2023",
//     },
//     {
//       name: "Halima Yusuf",
//       age: 38,
//       location: "Mogadishu, Somalia",
//       text: "My husband and I had incompatible blood groups — he is O positive and I am B positive. We were told transplant was impossible back home. The team at Apollo Delhi performed an ABO-incompatible transplant after a two-week desensitisation protocol. My kidney has been functioning perfectly for 14 months.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/58.jpg",
//       treatment: "ABO-Incompatible Living Donor Kidney Transplant",
//       date: "November 2023",
//     },
//     {
//       name: "Kwame Asante",
//       age: 29,
//       location: "Accra, Ghana",
//       text: "Polycystic kidney disease had destroyed both my kidneys by age 27. PaxGrow arranged a pre-emptive transplant using my mother as donor — before I even needed dialysis. The surgery at Chennai was flawless and the recovery was smoother than I ever imagined. I am now back to work full time.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/37.jpg",
//       treatment: "Pre-Emptive Living Donor Kidney Transplant — PKD",
//       date: "January 2024",
//     },
//   ],
// };

// const KIDNEY_TRANSPLANT_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for Kidney Transplant",
//   whyIndiaReasons: [
//     "India performs over 8,000 kidney transplants annually — one of the highest volumes globally — with 94–97% one-year graft survival at top centres",
//     "Multidisciplinary transplant boards review international cases within 48 hours of receiving medical reports — urgent cases prioritised same day",
//     "Living donor surgery confirmed within 2–3 weeks — compared to 3–7 year deceased donor waiting lists in the UK, USA or Canada",
//     "Apollo, AIIMS, Medanta, Fortis, Madras Medical Mission, MIOT — globally ranked transplant programmes with full published outcome transparency",
//   ],
//   conditionsTitle: "Kidney Conditions We Facilitate Transplant Treatment For",
//   conditions: [
//     "End-Stage Renal Disease (ESRD)",
//     "Diabetic Nephropathy",
//     "Hypertensive Nephropathy",
//     "Chronic Glomerulonephritis",
//     "Polycystic Kidney Disease (PKD)",
//     "IgA Nephropathy",
//     "Focal Segmental Glomerulosclerosis (FSGS)",
//     "Lupus Nephritis",
//     "Reflux Nephropathy",
//     "Alport Syndrome",
//     "Failed Previous Kidney Transplant (Re-Transplant)",
//     "Paediatric Kidney Disease",
//   ],
//   stayValue:
//     "Recipients: 3–4 weeks total (10–14 days hospital + 7–10 days outpatient monitoring). Living donors: 3–4 days hospital stay. PaxGrow arranges serviced accommodation near the hospital for the full recovery period.",
//   costTitle: "Why India for Kidney Transplant?",
//   costRows: [
//     {
//       procedure: "Living Donor Kidney Transplant (full package)",
//       india: "₹8L–₹12L",
//       africa: "Largely unavailable",
//       ukusa: "$150,000–$300,000",
//     },
//     {
//       procedure: "ABO-Incompatible Kidney Transplant",
//       india: "₹10L–₹15L",
//       africa: "Largely unavailable",
//       ukusa: "$200,000–$350,000",
//     },
//     {
//       procedure: "Paediatric Kidney Transplant",
//       india: "₹9L–₹13L",
//       africa: "Largely unavailable",
//       ukusa: "$150,000–$300,000",
//     },
//     {
//       procedure: "Re-Transplant (Failed Graft)",
//       india: "₹10L–₹16L",
//       africa: "Largely unavailable",
//       ukusa: "$200,000–$400,000",
//     },
//     {
//       procedure: "Post-Transplant Immunosuppression (per month)",
//       india: "₹8,000–₹18,000",
//       africa: "$600–$1,500",
//       ukusa: "$2,000–$5,000",
//     },
//   ],
// };

// const KidneyTransplantPage = () => {
//   return (
//     <TreatmentTemplate
//       treatment={KIDNEY_TRANSPLANT_TREATMENT}
//       paxgrowData={KIDNEY_TRANSPLANT_PAXGROW}
//     />
//   );
// };

// export default KidneyTransplantPage;


// src/pages/treatments/KidneyTransplantPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const KIDNEY_TRANSPLANT_TREATMENT = {
  slug: "kidney-transplant",
  name: "Kidney Transplant",
  shortName: "Kidney Transplant",
  tagline: "Freedom from Dialysis. A New Kidney. A New Life.",
  heroSubtag:
    "World-class kidney transplant surgery at a fraction of Western costs. India's top transplant nephrologists and urologists. Life-changing outcomes.",
  description:
    "Comprehensive kidney transplant care covering living donor, deceased donor and pre-emptive transplants — supported by advanced nephrology, dedicated transplant ICUs, immunosuppression management and lifelong post-transplant follow-up. Our multidisciplinary transplant boards review every international case within 48 hours to deliver globally benchmarked, personalised treatment plans with outstanding graft survival rates.",
  heroImage: "/KidneyTransplant.jpeg",
  category: "Organ Transplant",
  badge: "Life-Saving Surgery",
  accentColor: "blue",
  costCard: {
    label: "Kidney transplant packages",
    value: "$9,500–$14,500",
    compare: "vs. $150,000–$300,000 in the USA",
    stay: "Typically 3–4 weeks in India post-surgery",
    stayCompare: "vs. $100,000–$180,000 in the UK",
  },
  stats: [
    { label: "1-Year Graft Survival", value: "95%+", icon: Award },
    { label: "Transplants Performed", value: "8,000+", icon: Users },
    { label: "Years Experience", value: "30+", icon: Shield },
    { label: "Avg. Hospital Stay", value: "10–14 Days", icon: Clock },
  ],
  benefits: [
    "Living donor and deceased donor kidney transplant programmes",
    "Pre-emptive transplant — surgery before dialysis is required",
    "ABO-incompatible kidney transplant with desensitisation protocol",
    "Laparoscopic donor nephrectomy — minimal scarring, faster donor recovery",
    "Advanced HLA tissue typing and cross-matching laboratory on site",
    "Dedicated transplant nephrology team for lifelong immunosuppression management",
    "Comprehensive donor workup — medical, surgical, psychological and ethical evaluation",
    "Paediatric kidney transplant programme from infancy onwards",
  ],
  procedure: [
    {
      step: "01",
      title: "Evaluation & Recipient Work-Up",
      desc: "Complete nephrology assessment — GFR measurement, cardiac clearance, vascular imaging, HLA typing, donor compatibility testing and transplant committee approval.",
      duration: "5–7 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Living Donor Assessment",
      desc: "Independent full medical, surgical, psychological and ethical evaluation of the donor including renal function tests, CT angiography and 24-hour urine protein.",
      duration: "5–7 Days",
      icon: Activity,
    },
    {
      step: "03",
      title: "Transplant Surgery",
      desc: "Simultaneous laparoscopic donor nephrectomy and recipient kidney transplant by senior transplant urologist under general anaesthesia.",
      duration: "3–5 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Recovery & Long-Term Follow-Up",
      desc: "Transplant ICU monitoring, immunosuppression initiation, daily creatinine tracking and discharge with lifelong outpatient nephrology follow-up protocol.",
      duration: "10–14 Days",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "Who needs a kidney transplant?",
      a: "Kidney transplant is the gold-standard treatment for end-stage renal disease (ESRD) — when kidney function falls below 15% (GFR < 15 ml/min). Common causes include diabetic nephropathy, hypertensive nephropathy, glomerulonephritis, polycystic kidney disease and chronic pyelonephritis. A transplant offers a longer, better-quality life compared to dialysis.",
    },
    {
      q: "What is a living donor kidney transplant?",
      a: "A healthy family member or spouse (typically aged 18–60, blood group compatible) donates one of their two kidneys. People live full, healthy lives with one kidney. The donor undergoes laparoscopic (keyhole) nephrectomy and is typically discharged within 3–4 days. Living donor transplants have better long-term outcomes than deceased donor transplants.",
    },
    {
      q: "What is ABO-incompatible kidney transplant?",
      a: "Normally, donor and recipient must have compatible blood groups. ABO-incompatible transplant uses a desensitisation protocol — plasmapheresis and rituximab — to remove blood group antibodies before surgery, allowing transplantation across blood groups. India's top centres perform this routinely with excellent outcomes, opening options for patients whose only available donor has an incompatible blood group.",
    },
    {
      q: "What is the graft survival rate for kidney transplant in India?",
      a: "Leading Indian transplant centres report 1-year graft survival rates of 94–97% and 5-year graft survival rates of 85–90% — comparable to the best transplant centres in the USA and Europe. Living donor transplants consistently outperform deceased donor transplants in long-term graft function.",
    },
    {
      q: "How long will I need to stay in India after kidney transplant?",
      a: "Recipients typically stay 3–4 weeks post-surgery — approximately 10–14 days in hospital followed by 7–10 days of close outpatient monitoring before being cleared to fly. The living donor is usually discharged within 3–4 days. PaxGrow arranges serviced accommodation near the hospital for accompanying family throughout the recovery period.",
    },
    {
      q: "Can I bring my own living donor from my home country?",
      a: "Yes. Many international patients travel with a family member as the living donor. PaxGrow arranges medical visas for both recipient and donor simultaneously. The donor undergoes full independent evaluation at the Indian hospital before surgery is confirmed. Blood group compatibility and proof of relationship (or affidavit for emotionally related donors) are required.",
    },
    {
      q: "What immunosuppression will I need after kidney transplant?",
      a: "All kidney transplant recipients require lifelong immunosuppression. The standard triple therapy includes tacrolimus, mycophenolate mofetil and prednisolone. Your Indian transplant team provides a detailed protocol and coordinates with your home nephrologist for ongoing prescriptions. Monthly blood monitoring of creatinine, tacrolimus levels and full blood count is required for life.",
    },
    {
      q: "How much does kidney transplant cost in India vs. the UK or USA?",
      a: "A complete kidney transplant package in India (including donor evaluation, surgery, hospital stay, immunosuppression initiation and 30-day follow-up) typically costs $10,000–$15,000, compared to $100,000–$180,000 in the UK and $150,000–$300,000 in the USA — with equivalent or superior graft survival outcomes at top Indian centres.",
    },
  ],
  doctors: [
    {
      name: "Dr. Sandeep Guleria",
      specialty: "Kidney Transplant & Urology",
      experience: "28 Years",
      rating: 4.9,
      reviews: 3400,
      image: "https://randomuser.me/api/portraits/men/52.jpg",
      qualifications: "MBBS, MS, MCh (Urology), FRCS",
      hospital: "Indraprastha Apollo Hospital, New Delhi",
    },
    {
      name: "Dr. Georgi Abraham",
      specialty: "Transplant Nephrology",
      experience: "32 Years",
      rating: 4.9,
      reviews: 2900,
      image: "https://randomuser.me/api/portraits/men/63.jpg",
      qualifications: "MBBS, MD (Medicine), DM (Nephrology), FRCP",
      hospital: "Madras Medical Mission, Chennai",
    },
    {
      name: "Dr. Sunil Shroff",
      specialty: "Renal Transplant Surgery",
      experience: "30 Years",
      rating: 4.9,
      reviews: 3100,
      image: "https://randomuser.me/api/portraits/men/71.jpg",
      qualifications: "MBBS, MS, MCh (Urology), FRCS (Edinburgh)",
      hospital: "MIOT International, Chennai",
    },
  ],
  testimonials: [
    {
      name: "John Odhiambo",
      age: 44,
      location: "Nairobi, Kenya",
      text: "I had been on haemodialysis three times a week for two years. It was destroying my quality of life. My brother donated one of his kidneys in Delhi. Ten days after surgery my creatinine was 1.1 — completely normal. I flew home after three weeks and have not been on dialysis since. PaxGrow handled every single detail from visa to airport pickup to accommodation. I owe my life to this team.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/44.jpg",
      treatment: "Living Donor Kidney Transplant — Diabetic Nephropathy",
      date: "September 2023",
    },
    {
      name: "Halima Yusuf",
      age: 38,
      location: "Mogadishu, Somalia",
      text: "My husband and I had incompatible blood groups — he is O positive and I am B positive. We were told transplant was impossible back home. The team at Apollo Delhi performed an ABO-incompatible transplant after a two-week desensitisation protocol. My kidney has been functioning perfectly for 14 months.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/58.jpg",
      treatment: "ABO-Incompatible Living Donor Kidney Transplant",
      date: "November 2023",
    },
    {
      name: "Kwame Asante",
      age: 29,
      location: "Accra, Ghana",
      text: "Polycystic kidney disease had destroyed both my kidneys by age 27. PaxGrow arranged a pre-emptive transplant using my mother as donor — before I even needed dialysis. The surgery at Chennai was flawless and the recovery was smoother than I ever imagined. I am now back to work full time.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/37.jpg",
      treatment: "Pre-Emptive Living Donor Kidney Transplant — PKD",
      date: "January 2024",
    },
  ],
};

const KIDNEY_TRANSPLANT_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African & Gulf Patients Choose India for Kidney Transplant",
  whyIndiaReasons: [
    "India performs over 8,000 kidney transplants annually — one of the highest volumes globally — with 94–97% one-year graft survival at top centres",
    "Multidisciplinary transplant boards review international cases within 48 hours of receiving medical reports — urgent cases prioritised same day",
    "Living donor surgery confirmed within 2–3 weeks — compared to 3–7 year deceased donor waiting lists in the UK, USA or Canada",
    "Apollo, AIIMS, Medanta, Fortis, Madras Medical Mission, MIOT — globally ranked transplant programmes with full published outcome transparency",
  ],
  conditionsTitle: "Kidney Conditions We Facilitate Transplant Treatment For",
  conditions: [
    "End-Stage Renal Disease (ESRD)",
    "Diabetic Nephropathy",
    "Hypertensive Nephropathy",
    "Chronic Glomerulonephritis",
    "Polycystic Kidney Disease (PKD)",
    "IgA Nephropathy",
    "Focal Segmental Glomerulosclerosis (FSGS)",
    "Lupus Nephritis",
    "Reflux Nephropathy",
    "Alport Syndrome",
    "Failed Previous Kidney Transplant (Re-Transplant)",
    "Paediatric Kidney Disease",
  ],
  stayValue:
    "Recipients: 3–4 weeks total (10–14 days hospital + 7–10 days outpatient monitoring). Living donors: 3–4 days hospital stay. PaxGrow arranges serviced accommodation near the hospital for the full recovery period.",
  costTitle: "Why India for Kidney Transplant?",
  costRows: [
    {
      procedure: "Living Donor Kidney Transplant (full package)",
      india: "$9,500–$14,500",
      africa: "Largely unavailable",
      ukusa: "$150,000–$300,000",
    },
    {
      procedure: "ABO-Incompatible Kidney Transplant",
      india: "$12,000–$18,000",
      africa: "Largely unavailable",
      ukusa: "$200,000–$350,000",
    },
    {
      procedure: "Paediatric Kidney Transplant",
      india: "$11,000–$15,500",
      africa: "Largely unavailable",
      ukusa: "$150,000–$300,000",
    },
    {
      procedure: "Re-Transplant (Failed Graft)",
      india: "$12,000–$19,000",
      africa: "Largely unavailable",
      ukusa: "$200,000–$400,000",
    },
    {
      procedure: "Post-Transplant Immunosuppression (per month)",
      india: "$100–$220",
      africa: "$600–$1,500",
      ukusa: "$2,000–$5,000",
    },
  ],
};

const KidneyTransplantPage = () => {
  return (
    <TreatmentTemplate
      treatment={KIDNEY_TRANSPLANT_TREATMENT}
      paxgrowData={KIDNEY_TRANSPLANT_PAXGROW}
    />
  );
};

export default KidneyTransplantPage;